import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionTargetsFetchCurrentPayload,
	IActionTargetsFetchCurrentPayloadDone,
	IActionTargetsFetchCurrentPayloadError,
} from './types';

export const targetsFetchCurrent = actionCreatorAsync<
	IActionTargetsFetchCurrentPayload,
	IActionTargetsFetchCurrentPayloadDone,
	IActionTargetsFetchCurrentPayloadError
>(
	'targetsFetchCurrent',
	async () => {
		const { data } = await Api.targets.fetchCurrent();

		return data;
	},
);
